import React from "react";
import StatusApplication from "./StatusApplication";
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const RejectedApplications = () => {

  const editApplicationPermission = checkPermission(
    permissionsConfig.editRejectedApplications.role,
    permissionsConfig.editRejectedApplications.action,
    permissionsConfig.editRejectedApplications.type
  );
    
  const deleteApplicationPermission = checkPermission(
    permissionsConfig.deleteRejectedApplications.role,
    permissionsConfig.deleteRejectedApplications.action,
    permissionsConfig.deleteRejectedApplications.type
  );

  return (
    <StatusApplication appStatus="5" title="Rejected" subTitle="Rejected" application_type="0" pageFrom="rejected-applications" editApplicationPermission={editApplicationPermission} deleteApplicationPermission={deleteApplicationPermission}></StatusApplication>
  )
};

export default RejectedApplications;
